import React, { useState, useEffect } from 'react';
import { Layout } from 'antd';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from './components/Header';
import FloatingAdverts from './components/FloatingAdverts';
import ExclusiveOffersDrawer from './components/ExclusiveOffersDrawer';
import ChatSupportDrawer from './components/ChatSupportDrawer';
import SignUpModal from './components/SignUpModal';
import FooterComponent from './components/FooterComponent';
import RoutesConfig from './routes/RoutesConfig';
import SliderData from './data/SliderData';
import './assets/styles/App.css';

const { Content } = Layout;

const AppContent = ({ userRole, onLogout }) => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [chatVisible, setChatVisible] = useState(false);
  const [signUpVisible, setSignUpVisible] = useState(false);
  const [advertsVisible, setAdvertsVisible] = useState([true, true, true]);
  const [currentCompanyIndex, setCurrentCompanyIndex] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  // New state for AI talent features (example)
  const [leaderboardStats] = useState({ topUser: "John Doe", points: 1500 }); // Placeholder

  useEffect(() => {
    const timer = setTimeout(() => setPopupVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (location.pathname === '/signup') setSignUpVisible(true);
    else setSignUpVisible(false);
  }, [location.pathname]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCompanyIndex((prevIndex) => (prevIndex + 1) % companyAdverts.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const togglePopup = () => setPopupVisible(!popupVisible);
  const closeSignUp = () => {
    setSignUpVisible(false);
    navigate('/');
  };
  const handleCloseAdvert = (index) => {
    setAdvertsVisible((prev) => prev.map((visible, i) => (i === index ? false : visible)));
  };

  return (
    <Layout className="layout">
      <Helmet>
        <title>JectHub: Leading AI Talent Platform</title>
        <meta name="description" content="Transform your career with tuition-free AI, Data Science, and Cybersecurity training, mentorship, and job opportunities." />
        <meta name="keywords" content="AI Talent, Data Science, Cybersecurity, Machine Learning, Job Matching" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <Header
        userRole={userRole}
        onLogout={onLogout}
        drawerVisible={drawerVisible}
        setDrawerVisible={setDrawerVisible}
        setChatVisible={setChatVisible}
      />

      <Content style={{ padding: 0, margin: 0 }}>
        <RoutesConfig userRole={userRole} sliderData={SliderData} onLogout={onLogout} />
      </Content>

      <div style={{ backgroundColor: '#f0f2f5', textAlign: 'left', paddingTop: '20px' }}>
        <FooterComponent />
      </div>

      <SignUpModal visible={signUpVisible} onClose={closeSignUp} />

      <ExclusiveOffersDrawer visible={popupVisible} onClose={togglePopup} />

      <FloatingAdverts
        advertsVisible={advertsVisible}
        currentCompanyIndex={currentCompanyIndex}
        handleCloseAdvert={handleCloseAdvert}
        togglePopup={togglePopup}
        popupVisible={popupVisible}
      />

      <ChatSupportDrawer visible={chatVisible} onClose={() => setChatVisible(false)} />
    </Layout>
  );
};

const companyAdverts = [
  { title: 'Partner with Google', text: 'Collaborate on AI projects with Google experts.', buttonText: 'Join Now', path: '/participants/google', gradient: 'linear-gradient(45deg, #4285F4, #357ABD)', hoverGradient: 'linear-gradient(45deg, #357ABD, #2A62A0)' },
  { title: 'Team Up with Microsoft', text: 'Innovate with Microsoft’s tech community.', buttonText: 'Join Now', path: '/participants/microsoft', gradient: 'linear-gradient(45deg, #00A4EF, #0086C9)', hoverGradient: 'linear-gradient(45deg, #0086C9, #0068A3)' },
  { title: 'Work with IBM', text: 'Build cutting-edge solutions with IBM.', buttonText: 'Join Now', path: '/participants/ibm', gradient: 'linear-gradient(45deg, #1A73E8, #135ABF)', hoverGradient: 'linear-gradient(45deg, #135ABF, #0F4A9C)' },
  { title: 'Collaborate with AWS', text: 'Leverage AWS for your next big project.', buttonText: 'Join Now', path: '/participants/aws', gradient: 'linear-gradient(45deg, #FF9900, #D98200)', hoverGradient: 'linear-gradient(45deg, #D98200, #B36B00)' },
];

export default AppContent;